import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { IShelvesDto, IShelvesResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IShelvesResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.warehouses.shelves");
const postApis = createPostApi<
  IApiResponse<IShelvesResponse>,
  IPathBaseParam,
  IShelvesDto
>("stores.warehouses.shelves");
const getApis = createGetApi<
  IApiResponse<IShelvesResponse>,
  IPathByIdParam,
  object
>("stores.warehouses.shelves");
const patchApis = createPatchApi<
  IApiResponse<IShelvesResponse>,
  IPathByIdParam,
  IShelvesDto
>("stores.warehouses.shelves");

const deleteApis = createDeleteApi<
  IApiResponse<IShelvesResponse>,
  IPathByIdParam
>("stores.warehouses.shelves");

export const shelves = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
};
